import { MessageCircle, Mail } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CtaBanner } from "@/components/site/CtaBanner";
import { PlaceholderNotice, ReviewCard } from "@/components/site/ReviewBits";
import { EMAIL_HREF, SERVICES, WHATSAPP_URL } from "@/lib/site";

const CATS = [...SERVICES.map((s) => s.title), ...SERVICES.map((s) => s.title)];

export default function Reviews() {
  return (
    <>
      <Seo title="Customer Reviews | Easy Handyman Services Oxfordshire"
        description="Read what Oxfordshire customers say about Easy Handyman Services – home improvements, garden maintenance and house cleaning. Share your feedback with us." />
      <PageHero testId="reviews-hero" eyebrow="Customer reviews" lines={["Kind words from", "our customers."]}
        intro="We're collecting genuine feedback from the homeowners we work with. Real reviews will appear here as they come in." />
      <section className="bg-[var(--grey)] py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal className="mb-10"><PlaceholderNotice /></Reveal>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {CATS.map((c, i) => <ReviewCard key={i} n={i + 1} category={c} delay={(i % 3) * 0.08} />)}
          </div>
          <Reveal className="mt-14 rounded-[1.75rem] bg-white p-8 sm:p-12 grid gap-6 md:grid-cols-12 md:items-center">
            <div className="md:col-span-7">
              <h2 className="font-display text-2xl sm:text-3xl font-bold text-[var(--navy)]">Had work done by us?</h2>
              <p className="mt-3 text-[var(--body)]">We'd love to hear how it went. Send us your feedback and, with your permission, we may share it here.</p>
            </div>
            <div className="md:col-span-5 flex flex-col sm:flex-row gap-3 md:justify-end">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="reviews-feedback-whatsapp"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[var(--green)] px-6 py-3.5 font-semibold text-white hover:bg-[var(--green-hover)]">
                <MessageCircle className="h-4 w-4" /> WhatsApp feedback
              </a>
              <a href={`${EMAIL_HREF}?subject=My%20feedback`} data-testid="reviews-feedback-email"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-[var(--navy)] px-6 py-3.5 font-semibold text-[var(--navy)] hover:bg-[var(--navy)] hover:text-white transition-colors">
                <Mail className="h-4 w-4" /> Email feedback
              </a>
            </div>
          </Reveal>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
